import React from 'react';
import { I18n } from 'react-redux-i18n';
import { DropDown } from '../../../../common/dropdown';
import { connect } from 'react-redux';
import Validation from '../../../../helpers/Validation';
import Const from '../../Const';
import {
  changeCoveredWarrant,
  deleteMyCW,
  toggleConfirmPopupCreateWatchList,
  updateCustomWatchlist,
} from '../../reducer';
import { REDUCER_NAME } from './../../reducer';

class FilterCoveredWarrant extends React.PureComponent {
  handleUpdate = (key, name) => {
    const { updateCW, toggleConfirmPopupCreateWatchList } = this.props;

    const validation = new Validation(name);
    let messages = validation
      .isEmpty()
      .startWithAlphabetOrNumber()
      .limitCharacter(50).messages;
    if (messages.length > 0) {
      toggleConfirmPopupCreateWatchList(true, 'message.invalid_name_title', [
        I18n.t('message.invalid_name_message'),
      ]);
    } else {
      updateCW(key, name, Const.watchListType.CUSTOM_CW);
    }
  };

  render() {
    const {
      watchListId,
      listMyCW,
      listMyCWByKey,
      currentCoveredWarrant,
      changeCoveredWarrant,
      deleteMyCW,
    } = this.props;
    return (
      <DropDown
        id={watchListId}
        keyTitle="text"
        listKey={listMyCW}
        listDataByKey={listMyCWByKey}
        currentKey={currentCoveredWarrant}
        change={changeCoveredWarrant}
        update={this.handleUpdate}
        isEditable={true}
        deleteAction={deleteMyCW}
        isI18n={true}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    currentCoveredWarrant: state[REDUCER_NAME].currentCoveredWarrant,
    listMyCW: state[REDUCER_NAME].listMyCW,
    listMyCWByKey: state[REDUCER_NAME].listMyCWByKey,
    watchListId: state[REDUCER_NAME].watchListId,
  };
};

const mapDispatchToProps = {
  changeCoveredWarrant,
  deleteMyCW,
  toggleConfirmPopupCreateWatchList,
  updateCW: updateCustomWatchlist,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FilterCoveredWarrant);
